import { InventoryProvider } from './InventoryContext';
import Inventory from './Inventory';
import { Page } from 'components';

let Index = () => {
    return (
        <InventoryProvider>
            <Page title="Inventory">
                <Inventory />
            </Page>
        </InventoryProvider>
    )
}

export default Index;